import { render, staticRenderFns } from "./DictWorkPositionRankListPage.vue?vue&type=template&id=01619a0f&"
import script from "./DictWorkPositionRankListPage.vue?vue&type=script&lang=ts&"
export * from "./DictWorkPositionRankListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports